import { ReactNode } from 'react';
import './index.css'

type QuantityButtonProps = {
    children: ReactNode;
    changeValue: () => void;
    size?: number
}

export function QuantityButton({ children, changeValue, size }: QuantityButtonProps) {
    return(
        <div className='button-quantity' style={size ? { width: size, height: size } : {}} onClick={changeValue}>
            { children }
        </div>
    )
}